import { useEffect, useState, useMemo } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { beneLookUp } from "../../../../redux/features/verifyPAN/verifyPAN";
import { beneSuccessDetail } from "../../../../redux/features/accounts/BeneficiaryAccount/createAccount";
import { formatAccountNumber } from "../../../../components/_utils/FormatAccountNumber";
import {
  resetInEdit,
  resetVerification,
} from "../../../../redux/features/verifyPAN/verifyPAN";
import StatusContainer from "../../../../components/_utils/CommonStatus/StatusContainer";
import TabsWeapperSection from "../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import InfoCard from "../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import CommonToast from "../../../../components/_utils/CommonToast";
import { setHideBreadCrumb } from "../../../../redux/features/hideBreadCrumb/hideBreadCrumb";

const FieldForcePanEditSuccess = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const [previousAssociated, setPreviousAssociated] = useState(0);
  const [gstData, setGstData] = useState({
    id: "",
    panNo: "",
    gstNo: "",
  });
  const [currentAccountDetails, setCurrentAccountDetails] = useState({
    id: "",
    name: "",
    bank_name: "",
    bank_acc_no: "",
    ifsc_code: "",
    category: "",
    pan: "",
  });

  useEffect(() => {
    dispatch(resetVerification());
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  useEffect(() => {
    const fetchPANSuccessDetail = async () => {
      let response = await dispatch(beneSuccessDetail(id));
      if (response?.error?.message === "Request failed with status code 404") {
        navigate("*");
      }
    };
    fetchPANSuccessDetail();
  }, [dispatch, id, navigate]);

  useEffect(() => {
    const storedValue = localStorage.getItem("haveAssociated");
    if (storedValue !== null) {
      setPreviousAssociated(JSON.parse(storedValue));
    }
  }, []);

  const { beneLookData } = useSelector((state) => state.verify);
  const { isSuccessLoading } = useSelector((state) => state.beneCreateAccount);

  const successDetail = useSelector(
    (state) => state.beneCreateAccount.beneSuccessData,
  );

  const beneficiaryAccount = useMemo(
    () => successDetail?.beneficiary_accounts[0] || {},
    [successDetail?.beneficiary_accounts],
  );

  useEffect(() => {
    if (beneficiaryAccount && Object.keys(beneficiaryAccount).length > 0) {
      const { id, name, bank_name, bank_acc_no, ifsc_code, category, pan_no } =
        beneficiaryAccount;
      setCurrentAccountDetails({
        id,
        name,
        bank_name,
        bank_acc_no,
        ifsc_code,
        category,
        pan: pan_no,
      });
    }
  }, [beneficiaryAccount]);

  const createTxn = () => {
    CommonToast({
      text: "Feature coming soon",
      icon: "https://q2pay.in/new_assets/common/detail_page/info.svg",
      variant: "var(--coming-soon)",
      buttonNeeded: false,
    });
  };
  const createAccount = () => {
    navigate("/field_force_account_dashboard/create_field_force_account", {
      state: currentAccountDetails,
    });
  };
  const viewDetailsHandler = () => {
    navigate(
      `/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/${id}`,
    );
  };
  const dashboardHandler = () => {
    navigate("/field_force_account_dashboard");
  };

  let haveApproved = beneLookData?.beneficiary_accounts?.find((val) => {
    return val?.approval_status === "approved";
  });
  let havePending = beneLookData?.beneficiary_accounts?.find((val) => {
    return val?.approval_status === "pending" && val?.id !== id;
  });

  useEffect(() => {
    if (!isSuccessLoading && successDetail) {
      dispatch(
        beneLookUp({
          pan_number: successDetail?.beneficiary_accounts[0]?.pan_no,
        }),
      );
    }
    return () => {
      dispatch(resetInEdit());
    };
  }, [dispatch, isSuccessLoading, successDetail]);

  useEffect(() => {
    let data = sessionStorage.getItem("Pan Gst Verification");
    setGstData(JSON.parse(data));
  }, []);
  const buttonRows = [
    [
      {
        btnText: "Create account",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: "https://q2pay.in/new_assets/common/create_flow/create_new_account.svg",
        handleFunction: createAccount,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
      {
        btnText: "Create transaction",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: "https://q2pay.in/new_assets/common/settings/add_button_white.svg",
        handleFunction: createTxn,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
      {
        btnText: "View details",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: "https://q2pay.in/new_assets/common/create_flow/view_details.svg",
        handleFunction: viewDetailsHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--bg-positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: "https://q2pay.in/new_assets/common/dashboard/dashboard.svg",
        handleFunction: dashboardHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "dark",
      },
    ],
  ];

  const shouldShowAssociatedTab =
    previousAssociated === false &&
    (haveApproved !== undefined || havePending !== undefined);

  const approvedAccounts =
    beneLookData?.beneficiary_accounts?.filter(
      (val) => val?.approval_status === "approved",
    ) || [];

  const pendingAccounts =
    beneLookData?.beneficiary_accounts?.filter(
      (val) => val?.approval_status === "pending" && val?.id !== id,
    ) || [];

  return (
    <>
      <StatusContainer
        isLoading={isSuccessLoading}
        status="success"
        hoverOption="white"
        title={`${
          gstData.panNo !== beneficiaryAccount?.pan_no &&
          gstData?.gstNo !== beneficiaryAccount?.gstin_detail
            ? "PAN and GST "
            : gstData?.gstNo !== beneficiaryAccount?.gstin_detail
              ? "GST "
              : gstData.panNo !== beneficiaryAccount?.pan_no
                ? "PAN "
                : "PAN and GST "
        }number updated successfully.`}
        buttonRows={buttonRows}
      >
        <TabsWeapperSection title="Account details">
          <>
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: beneficiaryAccount?.name ?? "Not available",
                  leftSubTitle: "Account name",
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              hoverable="black"
              rows={[
                {
                  leftTitle:
                    typeof beneficiaryAccount.category === "string"
                      ? beneficiaryAccount.category
                          .split(",")
                          .map((category) => category.trim())
                          .join(" , ")
                      : beneficiaryAccount.category,
                  leftSubTitle: "Assigned categories",
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: beneficiaryAccount?.pan_no,
                  leftSubTitle: "PAN number",
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: formatAccountNumber(
                    beneficiaryAccount?.bank_acc_no,
                  ),
                  leftSubTitle: "Account number",
                  ifsc: beneficiaryAccount?.ifsc_code,
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: beneficiaryAccount?.ifsc_code,
                  leftSubTitle: "IFSC code",
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: beneficiaryAccount?.contact_no
                    ? `+91 ${beneficiaryAccount.contact_no}`
                    : "Not available",
                  leftSubTitle: "Contact number",
                  icon: "https://q2pay.in/new_assets/common/create_flow/contact_number.svg",
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: beneficiaryAccount?.email_id || "Not available",
                  leftSubTitle: "Email ID",
                  icon: "https://q2pay.in/new_assets/common/create_flow/gmail_red_error.svg",
                },
              ]}
            />
            {beneficiaryAccount?.gstin_detail && (
              <InfoCard
                bgColor="var(--positive-card)"
                rows={[
                  {
                    leftTitle: beneficiaryAccount.gstin_detail,
                    leftSubTitle: "GSTIN (optional)",
                  },
                ]}
              />
            )}

            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: "Will come from API",
                  leftSubTitle: "Linked user",
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: "Will come from API",
                  leftSubTitle: "Transaction limit",
                },
              ]}
            />
          </>
        </TabsWeapperSection>
        {shouldShowAssociatedTab && (
          <TabsWeapperSection title="Accounts Associated to PAN">
            <>
              {haveApproved && approvedAccounts.length > 0 && (
                <>
                  {approvedAccounts.map((val, index) => (
                    <InfoCard
                      key={val?.id || index}
                      bgColor="var(--positive-card)"
                      header={true}
                      borderColor="var(--positive-bg)"
                      rightHeaderText="Approved account"
                      rightHeaderTextColor="var(--text-secondary)"
                      leftHeaderText={val?.name}
                      rows={[
                        {
                          leftTitle: formatAccountNumber(val?.bank_acc_no),
                          leftSubTitle: "Bank account number",
                          ifsc: val?.ifsc_code,
                        },
                      ]}
                    />
                  ))}
                </>
              )}
              {havePending && pendingAccounts.length > 0 && (
                <>
                  {pendingAccounts.map((val, index) => (
                    <InfoCard
                      key={val?.id || index}
                      bgColor="var(--positive-card)"
                      header={true}
                      borderColor="var(--positive-bg)"
                      rightHeaderText="Pending account"
                      rightHeaderTextColor="var(--text-secondary)"
                      leftHeaderText={val?.name?.toLowerCase()}
                      rows={[
                        {
                          leftTitle: formatAccountNumber(val?.bank_acc_no),
                          leftSubTitle: "Bank account number",
                          ifsc: val?.ifsc_code,
                        },
                      ]}
                    />
                  ))}
                </>
              )}
              {!haveApproved &&
                !havePending &&
                (!beneLookData?.beneficiary_accounts ||
                  beneLookData.beneficiary_accounts.length === 0) && (
                  <InfoCard
                    bgColor="var(--positive-card)"
                    rows={[
                      {
                        leftTitle:
                          "  No associated accounts found for the PAN details provided",
                        leftSubTitle:
                          " There are no existing accounts that are associated with the PAN details provided.",
                      },
                    ]}
                  />
                )}
            </>
          </TabsWeapperSection>
        )}
      </StatusContainer>
    </>
  );
};

export default FieldForcePanEditSuccess;
